export default "__VITE_ASSET__DxycD24v__"